import html_iway from "./template.iway.html?raw";
import { defineComponent } from "vue";

const app_theme = import.meta.env.VITE_APP_THEME;
let html = "";
if ("iway" == app_theme) {
  html = html_iway;
} else if ("lic" == app_theme) {
  html = html_iway;
} else if ("sak" == app_theme) {
  html = html_iway;
}

export default defineComponent({
  template: html,
  props: {
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  emits: {
    toggle: () => true,
  },
});
